
export enum BankAccountProvider {
  None = 0,
  ManualAccount = 1,
  ExternalAccount = 2,
  UnitAccount = 3
}

export namespace BankAccountProvider {
  export function toString(bankAccountProvider: BankAccountProvider): string {
    switch (bankAccountProvider) {
      case BankAccountProvider.ManualAccount:
        return 'Manual Account';
      case BankAccountProvider.ExternalAccount:
        return 'External Account';
      case BankAccountProvider.UnitAccount:
        return 'Unit Account';
      default:
        return '';

    }
  }

  export function listAll(): BankAccountProvider[] {
    return [
      BankAccountProvider.ManualAccount,
      BankAccountProvider.ExternalAccount,
      BankAccountProvider.UnitAccount
    ]
  }

  export function pasre(bankAccountProviderStr: string): BankAccountProvider {
    return BankAccountProvider[bankAccountProviderStr];
  }
}
